import { alphabeticalSort } from "../../utils/stringUtils"
import currency from 'currency.js'
import styles from "./PayeeOrderSummary.module.css"

const PayeeOrderSummary = ({
    lineItemsById={},
    currencyText="EC",
    currencySymbol="$",
    feeList=[]
}) => {
    const lineItems = Object.values(lineItemsById)
                            .map(i => ({
                                ...i,
                                itemTotal: currency(i.price).multiply(i.quantity).value
                            }))
                            .sort((iA, iB) => alphabeticalSort(iA.name, iB.name))
    const subTotal = lineItems.reduce((sum, i) => currency(sum).add(i.itemTotal).value, 0)
    const totalList = [
        {total: subTotal, label: "Subtotal" },
        ...feeList
    ]
    const grandTotal = totalList.reduce((sum, t) => currency(sum).add(t.total).value, 0)
    return (
        <div className="card-group font-size-14px">
            <div className={`card overflow-y-auto ${styles.lineItemsContainer}`}>
            {
                lineItems.map(i => {
                    const {name="", quantity=0, variantDetails="", hasVariants=false, itemTotal=0} = i || {}
                    return <LineItem 
                                key={`${name}${variantDetails}`}
                                total={itemTotal}
                                label={`${quantity} x ${name}${hasVariants ? ` (${String(variantDetails).trim()})` : ""}`}
                                currencyText={currencyText}
                                currencySymbol={currencySymbol}
                           />

                })
            }
            </div>
            <div className="card">
                {
                    totalList.map(t => {
                        const {total=0, label=""} = t || {}
                        return (
                            <LineItem 
                                key={label}
                                total={total}
                                label={label}
                                currencyText={currencyText}
                                currencySymbol={currencySymbol}
                            />
                        )
                    })
                }
            </div>
            <div className="card">
                <b>
                    <LineItem 
                        total={grandTotal}
                        label="Total"
                        currencyText={currencyText}
                        currencySymbol={currencySymbol}
                    />
                </b>
            </div>
        </div>
    )
}

const LineItem = ({total=0, label="", currencySymbol="", currencyText}) => {
    return (
        <div className="display-flex justify-content-space-between margin-bottom-5px">
            <div className="display-flex flex-1 overflow-x-auto">{label}</div>
            <div className={`amount display-flex margin-left-5px ${styles.lineItemTotal}`}><em>{currencyText}{currencySymbol}{Number(total).toFixed(2)}</em></div>
        </div>
    )
} 
export default PayeeOrderSummary